import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

export default function useAutoLogout(timeout = 30 * 60 * 1000) { 
  const history = useHistory();
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      // Perform logout action here
      localStorage.removeItem("vs_UserSession"); 
      history.push("/login/");
    }, timeout);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    events.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer(); // start timer initially

    return () => {
      events.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
}